import React from 'react';

const NotFound = (props) => {

    console.log("404 error")

    return (
        <>
            <h1>404 SORRY COULDN'T FIND IT!!!</h1>
        </>
    )
}

export default NotFound;